<template>

  <div>

    <approval-remarks :row-data="actionData" :steps="actionData.steps" :legal-step="3" />

    <section v-if="isBackhaul">

        <backhaul-customer
          v-if="isTowerCo() && actionData.subActionType === 'CUST'"
          :sharer-id="actionData.organisation_id"
          :site-id="actionData.site_id"
          :action-id="actionData.id"
          :is-request="true" />

        <backhaul-provider
          v-else
          :provider-id="actionData.provider_id"
          :site-id="actionData.site_id"
          :action-id="actionData.id"
          :editable="isTelco() ? false : true"
          :is-request="true" />

    </section>

    <section v-if="isTowerCo() && canAccess('finance')">

        <el-form :inline="true">
            <el-form-item label="Agreement Type">

              <el-select
                v-model="step3.docType"
                placeholder="Select"
                filterable
                allow-create
                :disabled="!canAccess('finance') || disabled">

                <el-option
                   v-for="item in types"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
                 </el-option>

              </el-select>

          </el-form-item>
        </el-form>


      <p>Agreement Type: <b>{{step3.docType}}</b></p>

      <el-collapse v-model="accordion" v-if="!disabled" accordion>

      <el-collapse-item title="Finance Apprvoal of Legal Document" name="FinApprove" v-if="isTowerCo()">

          <el-alert type="info" :title="'Approval of ' + (step3.docType ? step3.docType : 'legal documents')" show-icon :closable="false">
            <check-box v-model="step3.legalApproved" no-form @change="legalChecked">{{(step3.docType ? step3.docType : 'Legal Document')}}</check-box>
            <span v-if="step.approved"><b>{{formatDate(step.approved_at)}}</b> by <b>{{step.approved_by}}</b></span>
          </el-alert>

          <el-alert
          v-if="this.isActive(this.actionData)"
          type="info1"
          title="Progress Remarks"
          show-icon />

          <html-input v-model="step.remarks" :disabled="isViewOnly() || !this.isActive(this.actionData)" />

      </el-collapse-item>

      <el-collapse-item v-if="isTowerCo() && !disabled && step.actionType === 'RTS'" title="Create Sharer" name="Sharer">
        <el-row>
          <h2 v-if="!step3.saved"><strong class="text-success">Add</strong> New Sharer</h2>
          <h3 v-else>Sharer already created</h3>
        </el-row>

        <licensee-form
        :site-id="rowData.site_id"
        :tower-id="site.siteId"
        :sharer-name="actionData.organisation.name"
        :sharer-id="actionData.organisation.id"
        :editable="step3.saved"
        :saved="step3.saved"
        :sharer-site-id="step2p2.state.siteId"
        :service-type="step2p2.state.serviceType"
        :spectrum-band="step2p2.state.spectrumBand"
        :equipment="step2.equipment" />
        <!-- @TODO need to figure out how to handle this: :editable="true" -->
      </el-collapse-item>

    </el-collapse>


    </section>


    <section v-else>

      <div v-if="isTowerCo()">
        <el-alert
          v-if="this.isActive(this.actionData) && step.remarks"
          type="info"
          title="Progress Remarks"
          :closable="false"
          show-icon />

          <html-input v-model="step.remarks" disabled no-form />
        </div>

        <div v-else>
          <el-alert
            v-if="this.isActive(this.actionData)"
            type="info"
            title="Progress Remarks"
            :closable="false"
            show-icon />

            <html-input v-model="step.remarks" no-form />

        </div>

    </section>

  </div>

</template>

<script>

import RequestMixins from '@/mixins/RequestMixins'

import FileDownload from '@/components/atoms/files/FileDownload'
import FileUpload from '@/components/atoms/files/FileUpload'

import LicenseeForm from '@/components/requests/LicenseeForm'

import BackhaulCustomer from '@/components/backhaul/BackhaulCustomer'
import BackhaulProvider from '@/components/backhaul/BackhaulProvider'

import ApprovalRemarks from '@/components/requests/workflow/ApprovalRemarks'

export default {

  mixins: [RequestMixins],

  components: {
    ApprovalRemarks,
    BackhaulCustomer,
    BackhaulProvider,
    FileDownload,
    FileUpload,
    LicenseeForm
  },

  props: {

    rowData: {
      type: Object,
      required: true
    },

    rowIndex: {
      type: Number,
      required: true
    },

    stepData: {
      type: Object,
      default: null
    },

    readOnly: {
      type: Boolean,
      default: true
    },

    isClosed: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    setStep (data) {
      if (data) {
        this.step = data

        // To handle existing RTx without this flag.
        this.step.legalApproved = (this.actionData.status !== 'Closed' ? this.step.legalApproved : true)
      }
    },

    legalChecked (check) {

      this.step.approved = check

      if (check) {
        this.step.approved_at = this.formatDateSql(new Date())
        this.step.approved_by = this.userName()
      } else {
        this.step.approved_at = null
        this.step.approved_by = null
      }
    }

  },



  data () {

    return {
      accordion: 'FinApprove',
      actionData: this.rowData,
      site: this.rowData.site,
      step: this.stepData,
      step2: this.rowData.state.step2,
      step2p2: null,
      step3p1: null,
      step3: this.rowData.state.step3,
      disabled: this.isViewOnly() || this.readOnly,
      types: [
        {
          value: 'LOO',
          label: 'LOO'
        }, {
          value: 'SLO',
          label: 'SLO'
        }, {
          value: 'AWO',
          label: 'AWO'
        }, {
          value: 'AAWO',
          label: 'AAWO'
        }, {
          value: 'AROW',
          label: 'AROW'
        }
      ]
    }

  }, // data



  created () {

    if (this.step) {

      if (!this.readOnly || !this.isViewOnly()) {
        if (this.canWriteStep()) {
          this.findStep(this.stepData.id, this.setStep)
        }

        if (!this.step.state.hasOwnProperty('saved')) {
          this.step.state.saved = false
        }

        this.step2p2 = this.findWorkflowStep(2, 2, this.rowData.steps)

        if (this.step && this.step.stepNo === 3 && this.step.partyNo === 1) {
          this.step3p1 = this.step
        } else {
          this.step3p1 = this.findWorkflowStep(3, 1, this.rowData.steps)
        }

        this.fixExistingEquipment() // just in case.

      }

    }

  },



  beforeDestroy () {

    if (!this.readOnly && this.step) {
      this.$emit('updated', this.step)

      if (this.canWriteStep() && (!this.readOnly || !this.isViewOnly())) {
        this.saveStep(this.step, null, this.actionData, true)
      }
    }
  }

}
</script>
